import { URL_API }  from '../include/urlApi.js';

/**
 * Fonction qui retourne une quertyString à partir d'un json simple
 * ex. {a:1,b:2} -> a=1&b=2.
 * 
 * @param {JSON} data 
 */
export function querystring(data) {
    return Object.keys(data).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k])).join('&');
}

/**
 * Les requête GET vers l'API.
 * 
 * @param {String} action nom de l'action à demander à l'API
 * @param {JSON} params Object JSON key=val qui sera parsé en querystring pour des paramètres additionnels
 * @return {Promise<Response>} Promise fetch
 */
export function getJson(action, params = null, requestOptions = { method: 'GET'}) {
    return fetch(`${URL_API}?action=${action}${(params) ? '&' + querystring(params) : ''}`, requestOptions).then(response => {
        if (response.ok) {
            return response.json().catch((err) => {
                console.error(action, params, requestOptions, err);
                throw new Error('error json');
            });
        } else {
            console.error(action, params, requestOptions, response);
            throw new Error('error response');
        }
    });
}

export function getErrMsg(errObj, lang) {
    let langCourante = lang || 'FR';
    let objErreur = errObj || {message: ''};
    let indice = 'message' + (langCourante === 'FR' ? '' : '_' + langCourante.toLowerCase())

    return objErreur[indice] ? objErreur[indice] : (objErreur['message'] ? objErreur['message'] : '');
}